import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatDateFr } from "../../lib/utils";
import { route } from "preact-router";
import { faEye, faTrash, faPen, faCog } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "preact/hooks";
import { deleteFormula } from "../../api/formulas";
import { NotificationContext } from "../notification-provider";

export default function FormulaTable(props) {

    const [deleteFormulaLoading, setDeleteFormulaLoading] = useState(false);
    const { addNotification }= useContext(NotificationContext);

    const removeFormula = (formulaKey) => {

        if (!confirm("Voulez-vous vraiment supprimer cette formule ?")) {
            return;
        }

        setDeleteFormulaLoading(formulaKey);

        deleteFormula(props.productKey, formulaKey).then(() => {
            addNotification("Formule supprimée avec succès", "success");
            if (props.onChange) {
                props.onChange();
            }
        }).catch((err) => {
            addNotification("Erreur lors de la suppression de la formule", "danger");
            console.error(err);
        }).finally(() => {
            setDeleteFormulaLoading(false);
        });
    }

    const columns = [
        {
            dataField: "key",
            text: "#",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "name",
            text: "Nom",
            sort: true,
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
        },
        {
            dataField: "created_at",
            text: "Créé à",
            sort: true,
            formatter: (cell, row) => {
                return formatDateFr(cell, true);
            }
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: (cell, row) => {
                return (
                    <>
                        <div className="btn-group" role="group" aria-label="Actions">
                            <button className="btn btn-sm btn-primary" onClick={(e) => {
                                e.stopPropagation();
                                route(`/products/${props?.productKey}/save-formula/${row.key}`);
                            }}>
                                <FontAwesomeIcon icon={faPen} />
                            </button>

                            <button disabled={deleteFormulaLoading === row.key} className="btn btn-sm btn-danger" onClick={(e) => {
                                e.stopPropagation();
                                removeFormula(row.key);
                            }}>
                                <FontAwesomeIcon icon={faTrash} />
                                {deleteFormulaLoading === row.key ? <Spinner animation="border" size="sm" /> : null}
                            </button>

                            <button className="btn btn-sm btn-secondary" onClick={(e) => {
                                e.stopPropagation();
                                route(`/formulas/${props?.productKey}/${row.key}/covers`);
                            }
                            }>
                                <FontAwesomeIcon icon={faCog} className="me-2" />
                                Garanties
                            </button>
                        </div>
                    </>
                )
            }
        }
    ];

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            e.stopPropagation();
            route(`/products/${props?.productKey}/save-formula/${row.key}`);
        }
    };

    return <>
        <ToolkitProvider keyField="key" data={props.formulas} columns={columns} exportCSV>
            {(props) => (
                <BootstrapTable
                                rowStyle={{ 
                                    cursor: 'pointer'
                                }}
                                rowClasses={(row, rowIndex) => {
                                    return 'cursor-pointer animate__animated animate__fadeIn';
                                }} pagination={paginationFactory(
                                    { hideSizePerPage: true, hidePageListOnlyOnePage: true }
                                )} rowEvents={rowEvents} classes={"align-middle"} bordered={false} striped hover {...props.baseProps} />
            )}
        </ToolkitProvider>
    </>
}